import { Box, FormControlLabel, Grid, Popover, Stack, Typography } from '@mui/material';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { convertTextToMultiLanguage } from 'common/utils/convert';
import { HexColorPickerDebounce } from 'common/utils/HexColorPickerDebounce';
import { SwitchCustom } from 'components/Common/SwitchCustom';
import { useLayerSelectCardStyle } from 'components/MapView/MapViewStyle';
import { useCheckRTL } from 'hooks/common/useCheckRLF';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'store/hooks';

interface IPolygonLayer {
  id: number;
  index: number;
  label: string;
  visible: boolean;
  color: string;
  typeOfAnalytic: string;
  changeColorAnalyticsLayer: (id: number, color: string, typeOfAnalytic: string) => void;
  changeVisibleAnalyticsLayer: ActionCreatorWithPayload<number>;
  dataPoints?: any[] | null;
}

export const PolygonLayerTypeRange = ({
  changeColorAnalyticsLayer,
  changeVisibleAnalyticsLayer,
  typeOfAnalytic,
  id,
  label,
  visible,
  color,
  index,
}: IPolygonLayer) => {
  const classes = useLayerSelectCardStyle();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const renderLabel = (label: string) => {
    return t(convertTextToMultiLanguage(label, 'mapView'), label);
  };

  const { isRTL } = useCheckRTL();

  return (
    <Grid item xs={12} md={12}>
      <FormControlLabel
        labelPlacement={isRTL ? 'start' : 'end'}
        control={<SwitchCustom checked={visible} onClick={() => dispatch(changeVisibleAnalyticsLayer(index))} />}
        label={
          <Stack
            direction={isRTL ? 'row-reverse' : 'row'}
            spacing={1}
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}>
            {color && visible && (
              <Box
                sx={{
                  width: '14px',
                  height: '14px',
                  border: `1px solid ${color}`,
                  borderRadius: '100%',
                  backgroundColor: color,
                }}
                onClick={(e: any) => handleClick(e)}
              />
            )}
            <Typography className={classes.selectText}>{renderLabel(label)}</Typography>
          </Stack>
        }
      />
      <Popover
        id={'simple-popover'}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        sx={{
          '.MuiPopover-paper': {
            overflowX: 'initial',
            overflowY: 'initial',
          },
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 160,
          horizontal: 30,
        }}>
        <Box>
          <HexColorPickerDebounce
            style={{
              boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.2)',
              borderRadius: '10px',
            }}
            color={color}
            onChange={(_color: any) => changeColorAnalyticsLayer(id, _color, typeOfAnalytic)}
          />
        </Box>
      </Popover>
    </Grid>
  );
};
